import { createAction } from '@reduxjs/toolkit';

export const onError = createAction('[Error] onError');
export const onUhandledError = createAction('[Error] onUhandledError');
export const clearError = createAction('[Error] clearError');
export const onMapDirectionsError = createAction('[Error] onMapDirectionsError');
export const setHarError = createAction('[Error] setHarError');
